import { Transforms, Element, Node } from 'slate';
import { CustomEditor, NoteElement } from 'slate/types/slate';

export const isNote = (node: Node): node is NoteElement => Element.isElement(node) && node.type === 'note';

export const insertNote = (editor: CustomEditor) => {
  if (!editor.selection) {
    return;
  }

  Transforms.insertNodes(
    editor,
    {
      type: 'note',
      children: [
        {
          type: 'paragraph',
          children: [{ text: '' }],
        },
      ],
    },
    {
      at: editor.selection.focus,
    }
  );
};
